import React, {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import { WithChildren } from 'common/types';

import styles from './styles.module.scss';
import { OptionType } from '../Select/types';

export interface IRadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string,
  label?: string,
  image?: string,
  option: OptionType,
}

const RadioButton = forwardRef(({
  name,
  label,
  image,
  className,
  children,
  ...props
}: WithChildren<IRadioButtonProps>, ref: ForwardedRef<HTMLInputElement>) => (
  <div className={classNames(styles.wrapper, 'common-components-RadioButton__wrapper', className)}>
    {image && (
      <img
        className={classNames(styles.image, 'common-components-RadioButton__image')}
        src={image}
        alt={name}
      />
    )}
    <div className={classNames(styles.body, 'common-components-RadioButton__body')}>
      <input
        {...props}
        ref={ref}
        type="radio"
        id={`${props.value}`}
        name={name}
        className={classNames(styles.input, 'common-components-RadioButton__input')}
        tabIndex={0}
      />
      {!children && (
        <label
          htmlFor={`${props.value}`}
          className={classNames(styles.radioButton, 'common-components-RadioButton__radioButton', className)}
        >
          {label}
        </label>
      )}
      {children}
    </div>
  </div>
));

// @ts-ignore
export default RadioButton;
